<!-- Operations -->
<mat-accordion class="table-operations">
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title style="align-items: center">
        Operaciones
      </mat-panel-title>
      <div class="table-top-container">
        <button
          mat-icon-button
          [matMenuTriggerFor]="export"
          aria-label="Exportar"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>download</mat-icon>
        </button>

        <button
          mat-icon-button
          [matMenuTriggerFor]="columns"
          aria-label="Columnas"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>view_column</mat-icon>
        </button>

        <button
          mat-icon-button
          [matMenuTriggerFor]="constrains"
          aria-label="Constrains"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>brush</mat-icon>
        </button>
      </div>
    </mat-expansion-panel-header>
    <div class="operation-buttons-container" *ngIf="tableActionsConfig">
      <div *ngFor="let operation of tableActionsConfig.actions">
        <div class="table-bottom-container">
          <!-- (selectedRows.size == 0 && operation.mustHaveOneSelected) ||
              (selectedRows.size != 1 && operation.scope == 1) -->
          <div
            [matTooltipDisabled]="operation.performable.state"
            matTooltip="{{ operation.performable.tooltip }}"
          >
            <button
              [disabled]="!operation.performable.state"
              mat-stroked-button
              class="general-action"
              (click)="
                operation.confirmation
                  ? performGeneralActionConfirmation(operation)
                  : performGeneralAction(operation)
              "
            >
              <mat-icon
                *ngIf="operation?.icon"
                [ngStyle]="{
                  color:
                    (!operation.performable.state
                      ? 'gray'
                      : operation?.color) || 'currentColor'
                }"
                >{{ operation.icon }}</mat-icon
              >
              {{ operation.content }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<!-- Table -->
<div class="litotable-main-container">
  <div class="litotable-container mat-elevation-z4">
    <div class="table-container">
      <mat-drawer-container class="example-container" [hasBackdrop]="true">
        <mat-drawer #drawer mode="over" position="end">
          <ng-container *ngTemplateOutlet="sidenavMenu"></ng-container>
        </mat-drawer>
        <mat-drawer-content>
          <div *ngIf="dataSource" class="table-responsive">
            <table
              mat-table
              [dataSource]="dataSource"
              matSort
              (matSortChange)="announceSortChange($event)"
            >
              <!-- Columna de seleccion -->
              <ng-container matColumnDef="selection">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    (change)="masterToggle()"
                    [indeterminate]="
                      this.selectedRows.size != 0 && !isAllSelected()
                    "
                    [checked]="isAllSelected()"
                  >
                  </mat-checkbox>
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  style="background-color: rgba(255, 255, 255, 1)"
                >
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="selectionToogle($event.checked, row)"
                    [checked]="selectedRows.has(row)"
                    [disabled]="row.processing"
                  >
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- Resto de columnas -->
              <ng-container
                *ngFor="let column of displayedColumns.columns"
                matColumnDef="{{ column.name }}"
              >
                <!-- Column Header -->
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header="{{ column.propertyKey }}"
                  sortActionDescription="Sort by {{ column.propertyKey }}"
                  [class.header-borders]="tableConfigurations?.headerBorders"
                >
                  {{ column.name }}
                </th>
                <!-- Column Data -->
                <td
                  mat-cell
                  *matCellDef="let element"
                  #litotableTd
                  [class.cell-borders]="tableConfigurations?.headerBorders"
                >
                  <div
                    #content
                    style="transition: 0.3s all"
                    [ngStyle]="
                      litotableTd.parentElement?.style?.color
                        ? { color: litotableTd.parentElement?.style?.color }
                        : {}
                    "
                  >
                    <div *ngIf="column.type == columnTypes.STRING">
                      {{ element[column.propertyKey] }}
                    </div>
                    <div *ngIf="column.type == columnTypes.INTEGER">
                      {{ element[column.propertyKey] | number: "1.0-0" }}
                    </div>
                    <div *ngIf="column.type == columnTypes.FLOAT">
                      {{ element[column.propertyKey] | number: "1.2-4" }}
                    </div>
                    <div *ngIf="column.type == columnTypes.DATE">
                      {{
                        element[column.propertyKey]
                          | date: (column.format ? column.format : "short")
                      }}
                    </div>
                    <div *ngIf="column.type == columnTypes.CURRENCY">
                      {{ element[column.propertyKey] | currency }}
                    </div>
                    <div *ngIf="column.type == columnTypes.CUIT">
                      {{ element[column.propertyKey] | cuit: "-" }}
                    </div>
                    <div *ngIf="column.type == columnTypes.PHONE">
                      {{
                        element[column.propertyKey]
                          | phone: (column.format ? column.format : undefined)
                      }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Columna de Acciones -->
              <ng-container
                *ngIf="tableConfigurations?.actionsColumn"
                matColumnDef="actions"
              >
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  [class.header-borders]="tableConfigurations?.headerBorders"
                  class="actions-th"
                >
                  Acciones
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  [class.cell-borders]="tableConfigurations?.headerBorders"
                  style="padding: 0"
                  class="actions-td"
                >
                  <div>
                    <div
                      *ngFor="let action of tableConfigurations?.actionsColumn"
                    >
                      <button
                        [disabled]="row.processing"
                        *ngIf="action.confirmation"
                        mat-icon-button
                        matTooltip="{{ action.tooltip }}"
                        (click)="
                          performRowActionConfirmation(
                            action,
                            row,
                            action.confirmation
                          )
                        "
                      >
                        <mat-icon
                          [style]="{
                            color: row.processing ? 'lightgray' : action.color
                          }"
                          >{{ action.icon }}</mat-icon
                        >
                      </button>
                      <button
                        [disabled]="row.processing"
                        *ngIf="!action.confirmation"
                        mat-icon-button
                        matTooltip="{{ action.tooltip }}"
                        (click)="onRowActionClick(row, action)"
                      >
                        <mat-icon
                          [style]="{
                            color: row.processing ? 'lightgray' : action.color
                          }"
                          >{{ action.icon }}</mat-icon
                        >
                      </button>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Columnas de agrupacion -->
              <ng-container matColumnDef="empty-group">
                <th *matHeaderCellDef class="group-header-empty"></th>
              </ng-container>
              <ng-container
                *ngFor="let col of displayedColumns.columnGroups.groupColumns"
                matColumnDef="{{ col.name }}"
              >
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  [attr.colspan]="col.colspan"
                >
                  {{ col.name }}
                </th>
              </ng-container>
              <tr
                class="group-header"
                mat-header-row
                *matHeaderRowDef="displayedColumns.columnGroups.displayNames"
              ></tr>

              <!-- Encabezados de columnas -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns.columnNames"
              ></tr>

              <!-- Formato condicional de filas -->
              <tr
                mat-row
                [class.mat-row-selected]="selectedRows.has(row)"
                [class.mat-row-selected-borders]="
                  selectedRows.has(row) &&
                  tableConfigurations?.selectionStyle == 1
                "
                [class.mat-row-selected-shadow]="
                  selectedRows.has(row) &&
                  tableConfigurations?.selectionStyle == 2
                "
                [class.mat-row-borders]="tableConfigurations?.hoverStyle == 1"
                [class.mat-row-shadow]="tableConfigurations?.hoverStyle == 2"
                style="transition: 0.3s all"
                [ngStyle]="constrainedRows.has(row) ? row.rowStyle.style : ''"
                *matRowDef="let row; columns: displayedColumns.columnNames"
                [class.mat-row-processing]="row.processing"
              ></tr>

              <!-- Mensaje por defecto en caso de no haber datos o se este fetcheando -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  {{ fetching ? "fetching data" : "No data found" }}
                </td>
              </tr>
            </table>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>

      <!-- Footer action button -->
      <div class="table-bottom-container">
        <button
          mat-stroked-button
          class="footercell"
          (click)="performFooterAction()"
        >
          <mat-icon
            *ngIf="tableConfigurations?.footerAction?.icon"
            [ngStyle]="{
              color: tableConfigurations?.footerAction?.color || 'currentColor'
            }"
            >{{ tableConfigurations?.footerAction?.icon }}</mat-icon
          >
          {{ tableConfigurations?.footerAction?.content }}
        </button>
      </div>
    </div>

    <!-- Paginator -->
    <div class="table-bottom-container">
      <mat-paginator
        [pageSizeOptions]="tableConfigurations?.paginationSizes || [5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page"
      >
      </mat-paginator>
    </div>

    <!-- Progressbar -->
    <mat-progress-bar
      [mode]="fetching ? 'indeterminate' : 'determinate'"
    ></mat-progress-bar>
  </div>
</div>

<!-- Export Menu -->
<mat-menu #export="matMenu" xPosition="before">
  <div
    mat-menu-item
    style="text-align: center"
    (click)="$event.stopPropagation()"
    disabled="true"
  >
    Exportar
  </div>
</mat-menu>

<!-- Columns Selector Menu -->
<mat-menu #columns="matMenu" xPosition="before">
  <div
    mat-menu-item
    style="text-align: center"
    (click)="$event.stopPropagation()"
    disabled="true"
  >
    Columnas
  </div>
  <mat-divider></mat-divider>

  <div
    *ngFor="let column of displayedColumns.columns"
    mat-menu-item
    (click)="$event.stopPropagation()"
  >
    <mat-slide-toggle
      color="primary"
      (click)="$event.stopPropagation()"
      (change)="displayedColumns.changeColumnVisivility(column)"
      [checked]="column.visible"
    >
      {{ column.name }}
    </mat-slide-toggle>
  </div>
  <mat-divider></mat-divider>
  <div
    *ngFor="let group of displayedColumns.columnGroups.groupColumns"
    mat-menu-item
    (click)="$event.stopPropagation()"
  >
    <mat-slide-toggle
      color="accent"
      (click)="$event.stopPropagation()"
      (change)="
        group.toogleVisibbility($event.checked);
        displayedColumns.updateVisivility()
      "
      [checked]="group.checked"
    >
      {{ group.name }}
    </mat-slide-toggle>
  </div>
  <button
    mat-menu-item
    style="text-align: center"
    (click)="displayedColumns.allVisible(); $event.stopPropagation()"
  >
    Todas
  </button>
</mat-menu>

<!-- Constrains Menu -->
<mat-menu
  #constrains="matMenu"
  xPosition="before"
  style="padding: 0.5rem !important"
>
  <div
    mat-menu-item
    style="text-align: center"
    (click)="$event.stopPropagation()"
    disabled="true"
  >
    Estilos
  </div>
  <div
    mat-menu-item
    disableRipple="true"
    *ngFor="let constr of fieldConstrians"
    (click)="$event.stopPropagation()"
    [style]="{
      display: 'flex',
      'align-items': 'center',
      'justify-items': 'center',
      color: constr.constrain.style['color'],
      'background-color': constr.constrain.style['background-color'],
      'text-align': 'center'
    }"
  >
    <span style="flex-grow: 1; text-align: center">{{
      constr.constrainName
    }}</span>
    <button
      mat-icon-button
      matTooltip="remove"
      style="justify-self: flex-end; margin-left: 1rem"
      [matMenuTriggerFor]="constrainDeletionConfirm"
      [matMenuTriggerData]="{ data: constr }"
    >
      <mat-icon style="margin: auto">delete</mat-icon>
    </button>
    <button mat-icon-button style="justify-self: flex-end">
      <mat-icon style="margin: auto" matTooltip="hide">edit</mat-icon>
    </button>
    <button
      mat-icon-button
      style="justify-self: flex-end"
      (click)="
        constr.constrain.enable = !constr.constrain.enable; updateVisibility()
      "
    >
      <mat-icon style="margin: auto" matTooltip="hide">{{
        constr.constrain.enable ? "visibility" : "visibility_off"
      }}</mat-icon>
    </button>
  </div>

  <!-- Constrain Creator -->
  <div
    mat-menu-item
    style="text-align: center"
    (click)="$event.stopPropagation()"
  >
    <litotable-constrain-creator
      [columns]="displayedColumns.columns"
      (result-constrain)="addConstrain($event)"
      ><mat-icon style="margin: auto"
        >add_circle</mat-icon
      ></litotable-constrain-creator
    >
  </div>
</mat-menu>

<mat-menu #constrainDeletionConfirm="matMenu" xPosition="before">
  <ng-template matMenuContent let-constrain="data">
    <button
      mat-menu-item
      (click)="removeConstrain(constrain)"
      style="color: red; font-weight: 500"
    >
      confirm remove
    </button>
  </ng-template>
</mat-menu>

<mat-menu #constrain="matMenu" xPosition="before">
  <ng-template matMenuContent let-data="data">
    <mat-card
      (click)="$event.stopPropagation()"
      (keypress)="$event.stopPropagation()"
    >
      <mat-card-content
        (click)="$event.stopPropagation()"
        (keypress)="$event.stopPropagation()"
        class="constrain-mat-content"
      >
        <div
          class="constrain-mat-content-dual"
          (click)="$event.stopPropagation()"
          (keypress)="$event.stopPropagation()"
        >
          <app-lito-color-picker
            [colors]="tableConfigurations?.rowStyleColors"
            (result)="
              changeConstrainState($event, data.constrain, 'background-color')
            "
            content="Background"
          ></app-lito-color-picker>
          <app-lito-color-picker
            [colors]="tableConfigurations?.rowStyleColors"
            (result)="changeConstrainState($event, data.constrain, 'color')"
            content="Foreground"
          ></app-lito-color-picker>
        </div>
        <div
          [style]="{
            color: data.constrain.style['color'],
            'background-color': data.constrain.style['background-color'],
            'margin-bottom': '1rem',
            'text-align': 'center',
            padding: '0.5rem 0',
            width: '100%'
          }"
        >
          {{ data.constrain.values[0] }}
        </div>
        <mat-button-toggle-group
          name="fontStyle"
          aria-label="Font Style"
          (click)="$event.stopPropagation()"
          value="{{ data.constrain.type }}"
          (change)="
            changeConstrainState($event, data.constrain, 'number-type', false)
          "
        >
          <mat-button-toggle value="1">=</mat-button-toggle>
          <mat-button-toggle value="2">{{ "\>" }}</mat-button-toggle>
          <mat-button-toggle value="3">{{ "\<" }}</mat-button-toggle>
          <mat-button-toggle value="4">{{ "\<\>" }}</mat-button-toggle>
        </mat-button-toggle-group>
        <div
          *ngIf="data.constrain.type != numberConstrainType.BETWEEN"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          (keypress)="$event.stopPropagation()"
          style="display: flex; justify-content: space-between"
        >
          <mat-form-field
            style="width: 100%"
            appearance="fill"
            (click)="$event.stopPropagation()"
            (keypress)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <mat-label (click)="$event.stopPropagation()">VALOR</mat-label>
            <input
              type="number"
              step="100"
              (keydown)="$event.stopPropagation()"
              (keypress)="$event.stopPropagation()"
              (click)="$event.stopPropagation()"
              (change)="
                $event.stopPropagation();
                changeConstrainState(
                  $event,
                  data.constrain,
                  'number-value',
                  false
                )
              "
              (keyup)="
                $event.stopPropagation();
                changeConstrainState(
                  $event,
                  data.constrain,
                  'number-value',
                  false
                )
              "
              matInput
              placeholder=""
              value="{{ data.constrain.values[0] }}"
            />
          </mat-form-field>
        </div>
        <!-- BETWEEN -->
        <div
          *ngIf="data.constrain.type == numberConstrainType.BETWEEN"
          (click)="$event.stopPropagation()"
          (keypress)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          style="max-width: fit-content; display: flow-root"
        >
          <mat-form-field
            style="max-width: 45%; float: left"
            appearance="fill"
            (click)="$event.stopPropagation()"
            (keypress)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <mat-label (click)="$event.stopPropagation()">DESDE</mat-label>
            <input
              type="number"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (keypress)="$event.stopPropagation()"
              (change)="
                changeConstrainState(
                  $event,
                  data.constrain,
                  'number-value1',
                  false
                )
              "
              (keyup)="
                changeConstrainState(
                  $event,
                  data.constrain,
                  'number-value1',
                  false
                )
              "
              matInput
              placeholder=""
              value="{{ data.constrain.values[0] }}"
            />
          </mat-form-field>
          <mat-form-field
            style="max-width: 45%; float: right"
            appearance="fill"
            (click)="$event.stopPropagation()"
            (keypress)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <mat-label
              (click)="$event.stopPropagation()"
              (keypress)="$event.stopPropagation()"
              >HASTA</mat-label
            >
            <input
              type="number"
              step="100"
              (change)="
                changeConstrainState(
                  $event,
                  data.constrain,
                  'number-value2',
                  false
                )
              "
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (keypress)="$event.stopPropagation()"
              (keyup)="
                changeConstrainState(
                  $event,
                  data.constrain,
                  'number-value2',
                  false
                )
              "
              matInput
              placeholder=""
              value="{{ data.constrain.values[1] }}"
            />
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
</mat-menu>

<!-- sidenav-menu -->
<ng-template #sidenavMenu>
  <div style="padding: 1rem">
    <h2>
      <span *ngIf="_confirmation == 'single'">
        {{
          rowConfirmation
            ? rowConfirmation?.confirmationData?.title
            : "Confirmacion"
        }}
      </span>
      <span *ngIf="_confirmation == 'multiple'">
        {{
          generalConfirmation
            ? generalConfirmation?.confirmationData?.title
            : "Confirmacion"
        }}
      </span>
    </h2>
    <p>
      <span *ngIf="_confirmation == 'single'">
        {{ rowConfirmation?.confirmationData?.content }}
      </span>
      <span *ngIf="_confirmation == 'multiple'">
        {{ generalConfirmation?.confirmationData?.content }}
      </span>
    </p>

    <button
      mat-raised-button
      color="primary"
      style="margin-right: 0.5rem"
      (click)="
        drawer.toggle();
        _confirmation == 'single'
          ? onRowActionClick(rowConfirmation?.row, rowConfirmation!.action)
          : onGeneralActionClick(generalConfirmation!.action)
      "
    >
      accept
    </button>
    <button mat-raised-button color="warn" (click)="drawer.toggle()">
      cancel
    </button>
  </div>
</ng-template>
